import { API_ENDPOINT_HCE_GENERIC, AUTH_HEADER } from "../../constants/api.constants";
import { get } from "../httpServices";

export default async function hceService(institution_id, type, patient_id, person_id) {
  try {
    const promise = await get(API_ENDPOINT_HCE_GENERIC(institution_id, type, patient_id, person_id), AUTH_HEADER())
    return promise
  }
  catch (err) {
    console.log('Error al cargar alergias: ', err);
  }
}
